import React, { useLayoutEffect, useRef } from "react";
import { gsap } from "gsap";
import { flyInFromRight } from "./hooks/animations";

const FlyInText = ({ text, classes = "", waitForScroll = true }) => {
  const textArray = [];
  const textRef = useRef(null);
  for (let i = 0; i < text.length; i++) {
    textArray.push(text[i]);
  }
  const getGap = (c) => (c === " " ? " w-3" : " ");
  useLayoutEffect(() => {
    let q = gsap.utils.selector(textRef);
    flyInFromRight(q(".text-letter"), waitForScroll);
  });
  return (
    <div ref={textRef} className={classes + " flex w-full justify-center"}>
      {textArray.map((c, i) => (
        <div key={i} className={"text-letter" + getGap(c)}>
          {c}
        </div>
      ))}
    </div>
  );
};

export default FlyInText;
